module.exports = __webpack_public_path__ + "static/media/sub competency template.f8b433ef.xlsx";